import { render } from "./CheckboxDetail.vue?vue&type=template&id=af423fa6"
import script from "./CheckboxDetail.vue?vue&type=script&lang=js"
export * from "./CheckboxDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__